var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cascader',_vm._b({attrs:{"label":_vm.label,"prepend-icon":_vm.prependIcon,"no-data-text":_vm.noDataText_,"items":_vm.rules,"item-value":"id","content-width":"250","item-text":"name","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'l-cascader',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }